<template>
  <div>
    <br />
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType == 'customer_id' }"
                        @click="sortCall('customer_id')"
                      >
                        ID Contrato
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'customer_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'customer_id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'customer_id'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="200">ID Cliente</td>
                      <td nowrap class="text-center align-middle" width="200">Empresa</td>
                      <td nowrap class="text-center align-middle" width="150">CNPJ</td>
                      <td nowrap class="text-center align-middle" width="100">Mês</td>
                      <td nowrap class="text-center align-middle" width="50">Valor</td>
                      <td nowrap class="text-center align-middle" width="50">Observação</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.contr_id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.cnpj"
                        />
                      </td>
                      <td>
                        <SelectInvoiceBillingMonth
                          :selected="filters.billing_month"
                          @change="setFilter('billing_month', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por mês de cobrança"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.price_total"
                        />
                      </td>
                      <td></td>
                    </tr>
                    <tr v-for="(invoice, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ invoice.customer_contract.id }}</td>
                      <td class="text-center align-middle">{{ invoice.customer.id }}</td>
                      <td class="text-left align-middle">
                        {{ invoice.customer.customerable.name }}
                      </td>
                      <td class="text-center align-middle">
                        {{ invoice.customer.documents.value | cnpj | cpf }}
                      </td>
                      <td class="text-center align-middle">
                        {{ invoice.billing_month | month }}
                      </td>
                      <td nowrap class="text-center align-middle">
                        {{ invoice.price_total | money }}
                      </td>
                      <td nowrap class="text-center align-middle">
                        {{ invoice.customer_contract ? invoice.customer_contract.note : '' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = 1">
                        <i class="fal fa-angle-double-left"></i>
                      </a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        <i class="fal fa-angle-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">{{
                        data.current_page - 2
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">{{
                        data.current_page - 1
                      }}</a>
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">{{ data.current_page }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">{{
                        data.current_page + 1
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 == data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">{{
                        data.current_page + 2
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        <i class="fal fa-angle-right"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page">
                        <i class="fal fa-angle-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import SelectInvoiceBillingMonth from '@/components/forms/SelectInvoiceBillingMonth';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportContractsChatbotNoConsumption',
  props: ['start', 'finish'],
  components: {
    SelectInvoiceBillingMonth,
  },
  data() {
    return {
      sortType: localStorage.reportContractsChatbotNoConsumptionSortType
        ? localStorage.reportContractsChatbotNoConsumptionSortType
        : 'customer_id',
      sortReverse: localStorage.reportContractsChatbotNoConsumptionSortReverse
        ? JSON.parse(localStorage.reportContractsChatbotNoConsumptionSortReverse)
        : false,
      amount: localStorage.reportContractsChatbotNoConsumptionDataAmount
        ? localStorage.reportContractsChatbotNoConsumptionDataAmount
        : 100,
      page: localStorage.reportContractsChatbotNoConsumptionDataPage
        ? localStorage.reportContractsChatbotNoConsumptionDataPage
        : 1,
      filters: {
        contr_id: localStorage.reportContractsChatbotNoConsumptionFilterContrId
          ? localStorage.reportContractsChatbotNoConsumptionFilterContrId
          : '',
        id: localStorage.reportContractsChatbotNoConsumptionFilterId
          ? localStorage.reportContractsChatbotNoConsumptionFilterId
          : '',
        name: localStorage.reportContractsChatbotNoConsumptionFilterName
          ? localStorage.reportContractsChatbotNoConsumptionFilterName
          : '',
        cnpj: localStorage.reportContractsChatbotNoConsumptionFilterCnpj
          ? localStorage.reportContractsChatbotNoConsumptionFilterCnpj
          : '',
        billing_month: localStorage.reportContractsChatbotNoConsumptionFilterBillingMonth
          ? localStorage.reportContractsChatbotNoConsumptionFilterBillingMonth
          : '',
        price_total: localStorage.reportContractsChatbotNoConsumptionFilterPriceTotal
          ? localStorage.reportContractsChatbotNoConsumptionFilterPriceTotal
          : '',
      },
      data: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/invoice/downlod-report-chatbot/${this.convertFilters()}`;
      axios
        .post(url, this.filters)
        .then((res) => {
          const arrData = res.data;
          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_chatbots_sem_consumo`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);

          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.contr_id = '';
      this.filters.id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.filters.product = '';
      this.filters.sortType = 'customer_id';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('reportContractsChatbotNoConsumptionFilterId', this.filters.id);
      localStorage.setItem('reportContractsChatbotNoConsumptionFilterId', this.filters.contr_id);
      localStorage.setItem('reportContractsChatbotNoConsumptionFilterName', this.filters.name);
      localStorage.setItem('reportContractsChatbotNoConsumptionFilterCnpj', this.filters.cnpj);
      localStorage.setItem(
        'reportContractsChatbotNoConsumptionFilterProduct',
        this.filters.product
      );
      localStorage.setItem(
        'reportContractsChatbotNoConsumptionFilterBillingMonth',
        this.filters.billing_month
      );
      localStorage.setItem(
        'reportContractsChatbotNoConsumptionFilterPriceTotal',
        this.filters.price_total
      );
      localStorage.setItem('reportContractsChatbotNoConsumptionDataAmount', this.amount);
      localStorage.setItem('reportContractsChatbotNoConsumptionDataPage', this.page);
      localStorage.setItem('reportContractsChatbotNoConsumptionSortType', this.sortType);
      localStorage.setItem('reportContractsChatbotNoConsumptionSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}
      &contr_id=${this.filters.contr_id ? this.filters.contr_id : ''}
      &id=${this.filters.id ? this.filters.id : ''}
      &name=${this.filters.name ? this.filters.name : ''}
      &cnpj=${this.filters.cnpj ? this.filters.cnpj : ''}
      &billing_month=${this.filters.billing_month ? this.filters.billing_month : ''}
      &price_total=${this.filters.price_total ? this.filters.price_total : ''}
      &amount=${this.amount}&sortType=${this.sortType}
      &sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}
      &start=${this.start}&end=${this.finish ? this.finish : this.start}`;

      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/report/invoice/chatbot/${this.convertFilters()}`;
      axios.post(url, this.filters).then((res) => {
        this.data = res.data;
        this.$emit('updateLoading');
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
